import {BarcodeFormat as InternalBarcodeFormat} from './barcode-scanner.types';
import type {BarcodeFormat as ExternalBarcodeFormat} from '@zxing/library';

// this class maps barcode formats between external libraries implementations and ours implementation
export class BarcodeFormatMapper {

    private readonly mappings: BarcodeFormatMapping[];
    private readonly UNKNOWN_EXTERNAL_BARCODE_FORMAT_MSG: string = 'Unknown external barcode format!';
    private readonly UNKNOWN_INTERNAL_BARCODE_FORMAT_MSG: string = 'Unknown internal barcode format!';

    constructor(externalBarcodeFormat: typeof ExternalBarcodeFormat) {
        this.mappings =
            [
                {internal: InternalBarcodeFormat.AZTEC,             external: externalBarcodeFormat.AZTEC},
                {internal: InternalBarcodeFormat.CODABAR,           external: externalBarcodeFormat.CODABAR},
                {internal: InternalBarcodeFormat.CODE_39,           external: externalBarcodeFormat.CODE_39},
                {internal: InternalBarcodeFormat.CODE_93,           external: externalBarcodeFormat.CODE_93},
                {internal: InternalBarcodeFormat.CODE_128,          external: externalBarcodeFormat.CODE_128},
                {internal: InternalBarcodeFormat.DATA_MATRIX,       external: externalBarcodeFormat.DATA_MATRIX},
                {internal: InternalBarcodeFormat.EAN_8,             external: externalBarcodeFormat.EAN_8},
                {internal: InternalBarcodeFormat.EAN_13,            external: externalBarcodeFormat.EAN_13},
                {internal: InternalBarcodeFormat.ITF,               external: externalBarcodeFormat.ITF},
                {internal: InternalBarcodeFormat.MAXICODE,          external: externalBarcodeFormat.MAXICODE},
                {internal: InternalBarcodeFormat.PDF_417,           external: externalBarcodeFormat.PDF_417},
                {internal: InternalBarcodeFormat.QR_CODE,           external: externalBarcodeFormat.QR_CODE},
                {internal: InternalBarcodeFormat.RSS_14,            external: externalBarcodeFormat.RSS_14},
                {internal: InternalBarcodeFormat.RSS_EXPANDED,      external: externalBarcodeFormat.RSS_EXPANDED},
                {internal: InternalBarcodeFormat.UPC_A,             external: externalBarcodeFormat.UPC_A},
                {internal: InternalBarcodeFormat.UPC_E,             external: externalBarcodeFormat.UPC_E},
                {internal: InternalBarcodeFormat.UPC_EAN_EXTENSION, external: externalBarcodeFormat.UPC_EAN_EXTENSION},
            ];
    }

    public mapToInternal(format: ExternalBarcodeFormat): InternalBarcodeFormat {

        const internal = this.mappings.find((mapping) => mapping.external === format)?.internal;

        if (internal !== undefined) {
            return internal;
        } else {
            throw new Error(this.UNKNOWN_EXTERNAL_BARCODE_FORMAT_MSG);
        }
    }

    public mapFromInternal(format: InternalBarcodeFormat): ExternalBarcodeFormat {

        const external = this.mappings.find((mapping) => mapping.internal === format)?.external;

        if (external !== undefined) {
            return external;
        } else {
            throw new Error(this.UNKNOWN_INTERNAL_BARCODE_FORMAT_MSG);
        }
    }
}

interface BarcodeFormatMapping {
    internal: InternalBarcodeFormat;
    external: ExternalBarcodeFormat;
}



